import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  defaultAddress: {
    contact: null,
    addressLines: null,
    city: null,
    stateProvince: null,
    stateProvinceAbbr: null,
    postalCode: null,
    latitude: null,
    longitude: null
  },
  pageSize: storage.local.getItem(types.DISPATCH_PAGE_SIZE) || 10,
  searchTerm: storage.session.getItem(types.DISPATCH_SEARCH_TERM) || '',
  sortDir: storage.session.getItem(types.DISPATCH_SORT_DIR) || 'desc',
  orderBy: storage.session.getItem(types.DISPATCH_ORDER_BY) || 'lastEventDate',
  filterBy: parseInt(storage.local.getItem(types.DISPATCH_FILTER_BY)) || null,
  filterOptions: [],
  currentTech: null,
  currentTechs: [],
  techs: [],
  techMarkers: [],
  address: null,
  center: null,
  schedule: []
})



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/state.js